import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const TermsOfServicePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        sx={{ mb: 3 }}
      >
        Back
      </Button>
      
      <Typography variant="h3" component="h1" gutterBottom>
        Terms of Service
      </Typography>
      
      <Typography variant="subtitle1" color="text.secondary" gutterBottom>
        Effective Date: 8/24/25
      </Typography>
      
      <Box sx={{ mt: 4 }}>
        <Typography variant="body1" paragraph>
          Welcome to Sedra. These Terms of Service ("Terms") govern your access to and use of our business management software, services, and website (collectively, the "Service"), operated by Sedra ("we," "us," or "our").
        </Typography>
        
        <Typography variant="body1" paragraph>
          By checking the box to agree or by accessing or using the Service, you agree to be bound by these Terms. If you do not agree, do not use the Service.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          1. ELIGIBILITY
        </Typography>
        <Typography variant="body1" paragraph>
          You must be at least 18 years old and capable of entering into a binding agreement to use the Service. By using the Service, you represent and warrant that you meet these requirements.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          2. ACCOUNT REGISTRATION
        </Typography>
        <Typography variant="body1" paragraph>
          To use the Service, you must register for an account. You agree to provide accurate and complete information and to keep your account credentials secure. You are responsible for any activity that occurs under your account.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          3. CLOSED BETA ACCESS
        </Typography>
        <Typography variant="body1" paragraph>
          Access to the Service during beta testing is limited and may be restricted by access codes. We may suspend or terminate beta accounts at our discretion.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          4. USE OF SERVICE
        </Typography>
        <Typography variant="body1" paragraph>
          You may use the Service only for lawful business purposes. You are responsible for your data, your customers' data, and compliance with any laws or regulations applicable to your business.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          5. USER-GENERATED CONTENT
        </Typography>
        <Typography variant="body1" paragraph>
          You retain all rights to content you create using the Service. You grant Sedra a license to use, store, and process your content solely to operate and improve the Service.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          6. PAYMENT TERMS
        </Typography>
        <Typography variant="body1" paragraph>
          While the Service is currently in beta, Sedra may introduce paid plans or premium features in the future. If you elect to subscribe, applicable pricing and billing terms will apply and will be disclosed prior to any charges.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          7. THIRD-PARTY SERVICES
        </Typography>
        <Typography variant="body1" paragraph>
          We integrate with third-party services like Stripe for payment processing. Your use of such services is governed by their respective terms and privacy policies.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          8. DATA SECURITY
        </Typography>
        <Typography variant="body1" paragraph>
          We implement reasonable safeguards to protect your data. However, no system is completely secure, and we cannot guarantee absolute security.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          9. TERMINATION
        </Typography>
        <Typography variant="body1" paragraph>
          We may suspend or terminate your access to the Service at any time if you violate these Terms. You may also delete your account at any time by contacting admin@sedrahq.com.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          10. DISCLAIMERS
        </Typography>
        <Typography variant="body1" paragraph>
          The Service is provided "as is" without warranties of any kind. We do not guarantee that the Service will be error-free, secure, or available at all times.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          11. LIMITATION OF LIABILITY
        </Typography>
        <Typography variant="body1" paragraph>
          To the maximum extent permitted by law, Sedra shall not be liable for any indirect, incidental, or consequential damages arising from your use of the Service.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          12. INDEMNIFICATION
        </Typography>
        <Typography variant="body1" paragraph>
          You agree to indemnify and hold harmless Sedra from any claims, damages, or legal costs arising from your use of the Service or violation of these Terms.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          13. GOVERNING LAW
        </Typography>
        <Typography variant="body1" paragraph>
          These Terms are governed by the laws of the State of New York, without regard to conflict of law principles. Any disputes shall be resolved in the courts of Rockland County, New York.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          14. CHANGES TO THESE TERMS
        </Typography>
        <Typography variant="body1" paragraph>
          We may modify these Terms from time to time. We will provide notice of material changes, and continued use of the Service after changes means you accept the updated Terms.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          15. CONTACT
        </Typography>
        <Typography variant="body1" paragraph>
          For questions about these Terms, contact us at: admin@sedrahq.com
        </Typography>

        <Box sx={{ mt: 4, p: 3, bgcolor: 'background.paper', borderRadius: 1, border: '1px solid', borderColor: 'divider' }}>
          <Typography variant="h6" gutterBottom>
            Sedra
          </Typography>
          <Typography variant="body2" color="text.secondary">
            5 Arcadian Dr, Spring Valley, NY 10977
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default TermsOfServicePage; 